/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './putPreferences.defs'
export { main as default } from './putPreferences.defs'
